module.exports = __webpack_public_path__ + "img/assure_v3.930c75f3.png";